export default (obj) => 'length' in Object(obj);
